import { GridLayout } from 'components';
import * as React from 'react';
import { SetState } from 'types';
import { DrawerState } from 'kineticUtils/hooks';

export interface Workspace {
  title: string;
  id: string;
  layout: GridLayout;
  isSystem?: boolean;
  gridItemData: Record<string, any>;
}

export interface WorkspaceContextState {
  workspaces: Record<string, Workspace>;
  currentWorkspace: string;
  setCurrentWorkspace: SetState<string>;
  mainMenuDrawerState: DrawerState;
  setMainMenuDrawerState: SetState<DrawerState>;
}

export const WorkspaceContext = React.createContext<WorkspaceContextState>({
  workspaces: {},
  currentWorkspace: '',
  setCurrentWorkspace: () => {},
  mainMenuDrawerState: { open: false, locked: false },
  setMainMenuDrawerState: () => {},
});
